export function createMediaQuery({
  minWidth,
  maxWidth,
  orientation
}) {
  return [minWidth && `(min-width: ${minWidth})`, maxWidth && `(max-width: ${maxWidth})`, orientation && `(orientation: ${orientation})`].filter(Boolean).join(' and ');
}